import React from 'react'

export default function ForgetPassword() {
    return (
        <div className='container'><h1>Forget Password screen</h1></div>
    )
}
